import './styles.scss'

import React, { useCallback, useEffect, useState } from 'react'
import { useActions, useValues } from 'kea'

import Checkbox from 'lib/forms/checkbox-svg'
import I18n from 'lib/i18n'

import filtersLogic from '~/scenes/search/filters-page/logic'
import searchLogic from '~/scenes/search/logic'

export default function TeacherLocation () {
  const { updateUnsavedFilter } = useActions(filtersLogic)
  const { receiveResults } = useActions(searchLogic)
  const { unsavedFilter } = useValues(filtersLogic)
  const { results, filter } = useValues(searchLogic)

  const [suggestions, setSuggestions] = useState([])
  const [text, setText] = useState('')
  const [inputClicked, setInputClicked] = useState(false)

  useEffect(() => {
    if (!unsavedFilter) return
    const { countries, teacher_country_code: teacherCountryCode } = unsavedFilter
    if (!countries) return

    const currentCountry = countries.find(country => teacherCountryCode === country.value)
    const textValue = currentCountry && teacherCountryCode && !text ? currentCountry.label : text

    if (textValue) {
      setText(textValue)
    }
  }, [text, unsavedFilter])

  const handleTextChange = event => {
    const { countries } = unsavedFilter
    const countryList = countries.map(country => country.label)
    const value = event.target.value
    let newSuggestions = []

    if (value && value.length > 0) {
      const regex = new RegExp(`^${value}`, 'i')
      newSuggestions = countryList.sort().filter(country => regex.test(country))
    }

    setSuggestions(newSuggestions)
    setText(value)
  }

  const suggestionSelected = useCallback(
    value => {
      const { countries } = unsavedFilter
      const country = countries.find(country => value === country.label)

      setText(value)
      setSuggestions([])
      updateUnsavedFilter({ teacher_country_code: country.value })
    },
    [unsavedFilter, updateUnsavedFilter]
  )

  const renderSuggestions = () => {
    if (suggestions.length === 0) {
      return null
    }

    return (
      <div className='suggestions-container'>
        {suggestions.map(country => (
          <p key={country} onClick={() => suggestionSelected(country)} className='super-label suggestions-result'>
            {country}
          </p>
        ))}
      </div>
    )
  }

  const handleLocationTypeChange = isWebcam => {
    updateUnsavedFilter({ webcam_anywhere: isWebcam, teacher_country_code: '' })
    setText('')
  }

  const handleBlur = () => {
    setInputClicked(false)
  }

  const handleFocus = () => {
    setInputClicked(true)

    if (!results) return

    const {
      helmet,
      helmet: { meta }
    } = results
    const metaArray = meta.filter(metaTag => metaTag.name !== 'viewport')

    receiveResults(
      {
        ...results,
        helmet: {
          ...helmet,
          meta: [
            ...metaArray,
            { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0' }
          ]
        }
      },
      filter
    )

    handleLocationTypeChange(false)
  }

  const { webcam_anywhere: webcamAnywhere } = unsavedFilter || {}

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.filters.teacher_location.placeholder')}</div>
      <div className='checkbox-list'>
        <Checkbox checked={webcamAnywhere} onChange={() => handleLocationTypeChange(true)}>
          {I18n.t('react.search.filters.teacher_location.anywhere')}
        </Checkbox>
        <Checkbox checked={!webcamAnywhere} onChange={() => handleLocationTypeChange(false)}>
          {I18n.t('react.search.filters.teacher_location.location')}
        </Checkbox>
      </div>
      <input
        type='text'
        className={`${inputClicked ? 'teacher-location-input input-clicked' : 'teacher-location-input'}`}
        placeholder={I18n.t('react.search.filters.teacher_location.location_placeholder')}
        value={text}
        onChange={handleTextChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {renderSuggestions()}
    </div>
  )
}
